import axios from "axios";
import { applyLanguageToRequest } from "../i18n/utils";

const apiUrl = process.env.REACT_APP_API_URL || "https://dev-api.lifechart.az";
export const baseURL = apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;

const request = axios.create({
  baseURL: baseURL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

request.interceptors.request.use(
  (config) => {
    const next = applyLanguageToRequest(config);
    const token = localStorage.getItem("token");
    if (token) {
      next.headers.Authorization = `Bearer ${token}`;
    }
    if (typeof FormData !== "undefined" && next.data instanceof FormData) {
      delete next.headers["Content-Type"];
      delete next.headers["content-type"];
    }
    return next;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = String(error.config?.url || "");
    const isAuthLogin = requestUrl.includes("auth/login");
    if (error.response?.status === 401 && !isAuthLogin) {
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
    }
    return Promise.reject(error);
  }
);

export default request;
